"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LengthDisplay = void 0;
const react_1 = __importDefault(require("react"));
const LengthDisplay = ({ value = 0, active }) => {
    return (react_1.default.createElement("span", { "data-tooltip-id": "tooltip", "data-tooltip-content": "\u6587\u5B57\u6570\u30AB\u30A6\u30F3\u30C8", style: {
            fontSize: "8px",
            backgroundColor: active ? "#2D73B9" : "#D9D9D9",
            color: active ? "#fff" : "#3F3F46",
            padding: "2px",
            borderRadius: "4px",
            position: "absolute",
            right: 2,
            transform: "translateY(calc(-100% - 2px))",
            whiteSpace: "nowrap",
        } },
        value,
        "\u6587\u5B57"));
};
exports.LengthDisplay = LengthDisplay;
